/**
 * Bytes across a bridge, as base64.
 *
 * Both things that cross the native bridge in this app do it the same way: a
 * downloaded bundle file on its way to the filesystem plugin, and a captured card
 * frame on its way from the camera plugin. Capacitor's own convention is base64 in
 * the JSON payload, and it is the only encoding that survives a bridge call
 * unchanged for arbitrary bytes - a `Uint8Array` arrives as an object with numeric
 * keys, and a latin1 string mangles anything above 0x7f.
 *
 * Chunked on the way out, because `String.fromCharCode(...bytes)` spreads one
 * argument per byte and blows the stack somewhere around a sixth of a megabyte -
 * which is smaller than a card frame.
 */

const CHUNK = 0x8000;

export function toBase64(bytes: Uint8Array): string {
  let binary = '';
  for (let offset = 0; offset < bytes.length; offset += CHUNK) {
    binary += String.fromCharCode(...bytes.subarray(offset, offset + CHUNK));
  }
  return btoa(binary);
}

export function fromBase64(base64: string): Uint8Array {
  return Uint8Array.from(atob(base64), (char) => char.charCodeAt(0));
}
